module.exports = __webpack_public_path__ + "img/thomas_wahl.e3bd1d43.png";